import React, { useState, useEffect, useCallback } from "react";
import "./blogstyle.css";
const API_BASE = window.location.origin;
const HOME_BASE = window.location.origin;


function BlogPost({ editMode, postId, reloadBlogPosts }) {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  const fetchPostData = useCallback(async () => {
    try {


 const response = await fetch(`${API_BASE}/api/fetch_post/${postId}`);



      const data = await response.json();
      setTitle(data.post.title);
      setContent(data.post.content);
    } catch (error) {
      console.error("Error fetching post data:", error);
    }
  }, [postId]);

  useEffect(() => {
    if (editMode && postId) {
      fetchPostData();
    }
  }, [editMode, postId, fetchPostData]);

  const handleSubmit = async () => {
    const url = editMode
      ? `${API_BASE}/api/edit_post/${postId}`
      : `${API_BASE}/api/create_post`;
    const method = editMode ? "PUT" : "POST";

    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ title, content }),
      });
      const result = await response.json();
      if (result.success) {
        alert("Post updated successfully");
        reloadBlogPosts();
        window.location.href = `${HOME_BASE}/`;
      } else {
        alert("Error updating post");
      }
    } catch (error) {
      console.error("Error during post update:", error);
    }
  };

  return (
    <div className="blog-form-container">
      <div className="blog-form">
        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <textarea
          placeholder="Content"
          value={content}
          onChange={(e) => setContent(e.target.value)}
        ></textarea>
        <button onClick={handleSubmit}>Submit</button>
        <br></br>
        <br></br>
        <button
           onClick={() => (window.location.href = `${HOME_BASE}/`)}
        >
          Go to Homepage
        </button>
      </div>
    </div>
  );
}

export default BlogPost;
